var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHashtagActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#59A3CF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st0",
    d: "M284.1,294.1l18.6-76.3h-74.4l-18.6,76.3H284.1z M512,144.4l-16.7,66c-0.9,4.7-4.7,7.4-9.3,7.4 h-96.7l-18.6,76.3h92.1c2.8,0,5.6,0.9,7.4,3.7c1.9,2.8,2.8,5.6,1.9,8.4l-16.7,66c-0.9,4.7-3.7,7.4-9.3,7.4h-96.7L325,476.5 c-0.9,4.7-4.7,7.4-9.3,7.4h-66c-2.8,0-5.6-0.9-7.4-3.7c-1.9-2.8-2.8-5.6-1.9-8.4l23.3-92.1h-75.3l-24.2,96.7 c-0.9,4.7-4.7,7.4-9.3,7.4h-67c-2.8,0-5.6-0.9-7.4-3.7c-1.9-2.8-2.8-5.6-1.9-8.4l23.3-92.1H9.7c-2.8,0-5.6-0.9-7.4-3.7 c-1.9-2.8-2.8-5.6-1.9-8.4l16.7-66c0.9-4.7,4.7-7.4,9.3-7.4h96.7l18.6-76.3H49.7c-2.8,0-5.6-0.9-7.4-3.7c-1.9-2.8-2.8-5.6-1.9-8.4 l16.7-66c0.9-4.7,3.7-7.4,9.3-7.4h96.7l24.2-96.7c0.9-4.7,4.7-7.4,9.3-7.4h66c2.8,0,5.6,0.9,7.4,3.7c1.9,2.8,2.8,5.6,1.9,8.4 l-23.3,92.1h75.3l24.2-96.7c0.9-4.7,4.7-7.4,9.3-7.4h66c2.8,0,5.6,0.9,7.4,3.7c1.9,2.8,2.8,5.6,1.9,8.4l-23.3,92.1h92.1 c2.8,0,5.6,0.9,7.4,3.7C512,138.8,512,141.6,512,144.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtagActive);
export default __webpack_public_path__ + "static/media/hashtag-active.0d69b88374a6f7f5b717e44a05b994a7.svg";
export { ForwardRef as ReactComponent };